// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import api from './customJs/api'
import 'animate.css'

import VueLazyload from 'vue-lazyload'

// meta图标
import VueMeta from 'vue-meta'
Vue.use(VueMeta)

Vue.use(Antd)

let loadimage
const userAgent = navigator.userAgent.toLowerCase()
console.log('userAgent', userAgent)
const mobileKeywords = ['iphone', 'android', 'windows phone']
const isMobile = mobileKeywords.some(keyword => userAgent.includes(keyword))
if (isMobile) {
  loadimage = require('./assets/loading.gif')
} else {
  loadimage = require('./assets/loading.gif')
}

Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: errorimage,
  loading: loadimage,
  attempt: 3

})

Vue.config.productionTip = false
Vue.prototype.$api = api

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js